import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { Lock, Users } from "lucide-react";
import api from "../lib/api";
import { maskPhoneBR } from "../lib/format";
import { toast } from "sonner";

export default function PhoneVerifyDialog({ open, onOpenChange, rideId, onVerified }) {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) {
      setPhone("");
      setError("");
      setLoading(false);
    }
  }, [open]);

  const verify = async (e) => {
    e?.preventDefault?.();
    setError("");
    const digits = phone.replace(/\D/g, "");
    if (digits.length !== 11) {
      setError("Digite o WhatsApp completo com DDD (11 dígitos).");
      return;
    }
    setLoading(true);
    try {
      const res = await api.post(`/rides/${rideId}/rsvp-verify`, { phone });
      if (res.data?.verified) {
        toast.success(`Bem-vindo${res.data.rider_name ? ", " + res.data.rider_name.split(" ")[0] : ""}!`);
        onVerified?.(res.data);
        onOpenChange(false);
      } else {
        setError("WhatsApp não encontrado neste rolê.");
      }
    } catch (err) {
      const status = err?.response?.status;
      const detail = err?.response?.data?.detail;
      if (status === 404) {
        setError(detail || "Não encontramos uma inscrição com esse WhatsApp neste rolê.");
      } else if (status === 403) {
        setError("A lista ainda não foi liberada pelo admin.");
      } else {
        setError(detail || "Erro ao validar. Tente novamente.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-md bg-[#12141D] border-white/10"
        data-testid="phone-verify-dialog"
      >
        <DialogHeader>
          <div className="flex items-center gap-2 mb-1">
            <Lock size={16} style={{ color: "#00E5FF" }} />
            <span className="label-caps" style={{ color: "#00E5FF" }}>
              Acesso Restrito
            </span>
          </div>
          <DialogTitle className="font-display text-2xl sm:text-3xl uppercase text-white">
            Validar Inscrição
          </DialogTitle>
          <div className="text-white/60 text-sm">
            Digite o WhatsApp que você usou pra confirmar presença. Só pilotos inscritos veem a lista.
          </div>
        </DialogHeader>

        <form onSubmit={verify} className="space-y-4 mt-2">
          <Input
            type="tel"
            inputMode="numeric"
            autoComplete="tel-national"
            value={phone}
            onChange={(e) => setPhone(maskPhoneBR(e.target.value))}
            placeholder="(85) 91234-5678"
            maxLength={16}
            className="bg-[#0B0D14] border-white/10 focus:border-[#00E5FF] rounded-sm h-12 text-base"
            data-testid="phone-verify-input"
            autoFocus
          />
          {error && (
            <div
              className="text-sm px-3 py-2 border"
              style={{
                color: "#F87171",
                borderColor: "rgba(248,113,113,0.35)",
                background: "rgba(248,113,113,0.05)",
              }}
              data-testid="phone-verify-error"
            >
              {error}
            </div>
          )}
          <Button
            type="submit"
            disabled={loading}
            className="btn-primary w-full h-12 text-sm inline-flex items-center gap-2 justify-center"
            data-testid="phone-verify-submit"
          >
            <Users size={14} />
            {loading ? "Validando..." : "Ver Lista de Presença"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
